export const configText ={
    hodap_qhqg: {
        id: 'STT',
        ten: 'Tên công trình',
        x: 'Toạ độ X',
        y: 'Toạ độ Y',
        Xa: 'Xã',
        huyen: 'Huyện',
        tinh: 'Tỉnh',
        phanloai: 'Phân loại',
        capquanly: 'Cấp quản lý',
        capkt: 'Cấp kỹ thuật',
        flv_km2: 'Diện tích lưu vực',
        wtb_trm3: 'Dung tích toàn bộ',
        whi: 'Dung tích hữu ích',
        wc: 'Dung tích chết',
        wpl_trm3: 'Dung tích phòng lũ',
        qmay: 'Q phát điện',
        mndbt: 'Mực nước dâng bình thường',
        mnc: 'Mực nước chết',
        mnltk: 'Mực nước lũ thiết kế',
        zdinhdap: 'Cao trình đỉnh đập',
        zdaydap: 'Cao trình đáy đập',
        ldap: 'Chiều dài đập',
        tran: 'Loại tràn',
        sokhoang: 'Số khoang tràn',
        ztran: 'Cao trình tràn',
        btran: 'Bề rộng tràn',
        qxa_ltk: 'Lưu lượng xả lũ thiết kế',
        donviql: 'Đơn vị quản lý',
        xdstart: 'Năm xây dựng',
        xdend: 'năm hoàn thành',
        tinhtrang: 'Tình trạng ',
        // nguon: 'nguon',
        // phanloai1: 'phanloai1',
    },
    cong_qhqg: {
        id: 'STT',
        ten: 'Tên công trình',
        X: 'Toạ độ X',
        Y: 'Toạ độ Y',
        xa: 'Xã',
        tenhuyen: 'Huyện',
        tentinh: 'Tỉnh',
        phanloai: 'Phân loại',
        capquanly: 'Cấp quản lý',
        capkythuat: 'Cấp kỹ thuật',
        khaudo: 'Khẩu độ',
        Zday: 'Cao trình đáy',
        ftuoiha: 'Diện tích tưới thiết kế',
        ftieuha: 'Diện tích tiêu thiết kế',
        donviql: 'Đơn vị quản lý',
        xdstart: 'Năm xây dựng',
        xdend: 'Năm hoàn thành',
        // tinhtrang: 'tinhtrang',
        // geo: 'geo',
        // nguon: 'nguon',
        // ngaythunha: 'ngaythunha',
        // ngaycapnha: 'ngaycapnha',
        // phanloai1: 'phanloai1',
    },
    trambom_ht:{
        FID: 'STT',
        ten: 'Tên công trình',
        madoituong: 'Mã đối tượng',
        diadiem: 'Địa điểm',
        phanloai: 'Phân loại',
        capquanly: 'Cấp quản lý',
        capkythuat: 'Cấp Kỹ thuật',
        dttuoi: 'Diện tích tưới thiết kế',
        dttieu: 'Diện tích tiêu thiết kế',
        luuluong: 'Lưu lượng',
        donviql: 'Đơn vị quản lý',
        xdstart: 'Năm xây dựng',
        xdend: 'Năm hoàn thành',
        tinhtrang: 'Tình trạng',
        // geo: 'geo',
        nguon: 'Đơn vị cấp thông tin',
        // ngaythunha: 'ngaythunha',
        // ngaycapnha: 'ngaycapnha',
        // phanloai2: 'phanloai2',
    },
    thuydien: {
        // FID: 'FID',
        stt: 'STT',
        ten: 'Tên công trình',
        long: 'Toạ độ X',
        lat: 'Toạ độ Y',
        xa: 'Xã',
        huyen: 'Huyện',
        tinh: 'Tỉnh',
        flv__km2: 'Diện tích lưu vực',
        nlm_mw: 'Công suất lắp máy',
        mntl_m: 'Mực nước thượng lưu',
        w_chet: 'Dung tích chết',
        w_huuich: 'Dung tích hữu ích',
        w_mndbt: 'Dung tích mực nước dâng bình thường',
        w_tong: 'Dung tích tổng cộng',
        mnc: 'Mực nước chết',
        mndbt: 'Mực nước dâng bình thường',
        mndgc: 'Mực nước dâng gia cường',
        nxd: 'Năm xây dựng',
        nht: 'Năm hoàn thành',
        dvql: 'Đơn vị quản lý',
    },
    TuyenChuyenNuoc: {
        fid: 'STT',
        ten_tuyen: 'Tên tuyến chuyển nước',
        muctieu: 'Mục tiêu',
        tinh: 'Tỉnh',
        Vung: 'Vùng',
        loai_ct: 'Loại công trình',
        loaihinh_d: 'Loại hình đầu tư',
        chieudai_k: 'Chiều dài',
        qchuyen_m3: 'Lưu lượng',
        ft_ha: 'Diện tích tưới',
        gd_2030: 'GĐĐT 2030',
        gd_sau2030: 'GĐĐT sau 2030',
        // Ghichu: 'Ghichu',
    },
    congtrinh_xaymoi: {
        // FID: 'FID',
        id: 'STT',
        tenct: 'Tên công trình',
        x: 'Toạ độ X',
        y: 'Toạ độ Y',
        tinh: 'Tỉnh',
        vung: 'Vùng',
        loai_ct: 'Loại công trình',
        loaidautu: 'Loại đầu tư',
        wh_trieum3: 'Dung tích hữu ích',
        ftuoi_ha: 'Diện tích tưới thiết kế',
        chonglu: 'Chống lũ',
        gd_2030: 'GĐĐT 2030',
        gd_sau2030: 'GĐĐT sau 2030',
        ghichu: 'Ghi chú',
        // phanloai1: 'phanloai1',
    },
    CongTrinh_nangcap: {
        // FID: 'FID',
        id: 'STT',
        tenct: 'Tên công trình',
        x: 'Toạ độ X',
        y: 'Toạ độ Y',
        tinh: 'Tỉnh',
        vung: 'Vùng',
        loai_ct: 'Loại công trình',
        loaidautu: 'Loại đầu tư',
        wh_trieum3: 'Dung tích tăng thêm',
        ftuoi_ha: 'Diện tích tưới',
        chonglu: 'Chống lũ',
        gd_2030: 'GĐĐT 2030',
        gd_sau2030: 'GĐĐT sau 2030',
        // ghichu: 'ghichu',
        // phanloai: 'phanloai',
    },
    NangCap_HTTL: {
        // id: 'id',
        tt: 'STT',
        hethong: 'Hệ thống',
        tenct: 'Tên hệ thống',
        muctieu: 'Mục tiêu',
        tinh: 'Tỉnh',
        vung: 'Vùng',
        loai_ct: 'Loại công trình',
        loaihinh_d: 'Loại hình đầu tư',
        ftuoi_ha: 'Diện tích tưới',
        ftieu_ha: 'Diện tích tiêu',
        gd_2030: 'GĐĐT 2030',
        gd_sau2030: 'GĐĐT sau 2030',
        // shape_leng: 'shape_leng',
        // shape_area: 'shape_area',
    },
    DanhMucQuyHoach: {
        // stt: 'STT',
        tenqhtl: 'Quy hoạch',
        tenlv: 'Lưu vực',
        no_qhtl: 'Số quyết định',
        nam_qh: 'Năm phê duyệt',
        sl_ctqh: 'Số công trình quy hoạch',
        soct_daxd: 'Số công trình đã xây dựng',
        // ftuoi_tl: 'Tỷ Ftưới theo QH',
    },
    HeSoTuoiTieu: {
        diadanh: <b>Vùng</b>,
        ptuoilua20: 'Tần suất tưới (Lúa, 2020)',
        ptuoilua30: 'Tần suất tưới (Lúa, 2030)',
        ptuoilua50: 'Tần suất tưới (Lúa, 2050)',
        htuoilua20: 'Hệ số tưới (Lúa, 2020)',
        htuoilua30: 'Hệ số tưới (Lúa, 2030)',
        htuoilua50: 'Hệ số tưới (Lúa, 2050)',
        ptieulua20: 'Tần suất tiêu (Lúa, 2020)',
        ptieulua30: 'Tần suất tiêu (Lúa, 2030)',
        ptieulua50: 'Tần suất tiêu (Lúa, 2050)',
        htieulua20: 'Hệ số tiêu Lúa, 2020)',
        htieulua30: 'Hệ số tiêu (Lúa, 2030)',
        htieulua50: 'Hệ số tiêu (Lúa, 2050)',
    }
}

export const configDonvi ={
    hodap_qhqg: {
        // id: 'STT',
        // ten: 'Tên công trình',
        // x: 'Toạ độ X',
        // y: 'Toạ độ Y',
        // Xa: 'Xã',
        // huyen: 'Huyện',
        // tinh: 'Tỉnh',
        // phanloai: 'Phân loại',
        // capquanly: 'Cấp quản lý',
        // capkt: 'Cấp kỹ thuật',
        flv_km2: 'Km2',
        wtb_trm3: 'Triệu m3',
        whi: 'Triệu m3',
        wc: 'Triệu m3',
        wpl_trm3: 'Triệu m3',
        qmay: 'm3/s',
        mndbt: 'm',
        mnc: 'm',
        mnltk: 'm',
        zdinhdap: 'm',
        zdaydap: 'm',
        ldap: 'm',
        // tran: 'Loại tràn',
        // sokhoang: 'Số khoang tràn',
        ztran: 'm',
        btran: 'm',
        // qxa_ltk: 'Lưu lượng xả lũ thiết kế',
        // donviql: 'Đơn vị quản lý',
        // xdstart: 'Năm xây dựng',
        // xdend: 'năm hoàn thành',
        // tinhtrang: 'Tình trạng ',
        // nguon: 'nguon',
        // phanloai1: 'phanloai1',
    },
    cong_qhqg: {
        // id: 'STT',
        // ten: 'Tên công trình',
        // X: 'Toạ độ X',
        // Y: 'Toạ độ Y',
        // xa: 'Xã',
        // tenhuyen: 'Huyện',
        // tentinh: 'Tỉnh',
        // phanloai: 'Phân loại',
        // capquanly: 'Cấp quản lý',
        // capkythuat: 'Cấp kỹ thuật',
        khaudo: 'm',
        Zday: 'm',
        ftuoiha: 'ha',
        ftieuha: 'ha',
        // donviql: 'Đơn vị quản lý',
        // xdstart: 'Năm xây dựng',
        // xdend: 'Năm hoàn thành',
        // tinhtrang: 'tinhtrang',
        // geo: 'geo',
        // nguon: 'nguon',
        // ngaythunha: 'ngaythunha',
        // ngaycapnha: 'ngaycapnha',
        // phanloai1: 'phanloai1',
    },
    trambom_ht:{
        // FID: 'STT',
        // ten: 'Tên công trình',
        // madoituong: 'Mã đối tượng',
        // diadiem: 'Địa điểm',
        // phanloai: 'Phân loại',
        // capquanly: 'Cấp quản lý',
        // capkythuat: 'Cấp Kỹ thuật',
        // dttuoi: 'Diện tích tưới thiết kế',
        // dttieu: 'Diện tích tiêu thiết kế',
        // luuluong: 'Lưu lượng',
        // donviql: 'Đơn vị quản lý',
        // xdstart: 'Năm xây dựng',
        // xdend: 'Năm hoàn thành',
        // tinhtrang: 'Tình trạng',
        // geo: 'geo',
        // nguon: 'Đơn vị cấp thông tin',
        // ngaythunha: 'ngaythunha',
        // ngaycapnha: 'ngaycapnha',
        // phanloai2: 'phanloai2',
    },
    thuydien: {
        // FID: 'FID',
        // stt: 'STT',
        // ten: 'Tên công trình',
        // long: 'Toạ độ X',
        // lat: 'Toạ độ Y',
        // xa: 'Xã',
        // huyen: 'Huyện',
        // tinh: 'Tỉnh',
        flv__km2: 'Km2',
        nlm_mw: 'MW',
        // mntl_m: 'Mực nước thượng lưu',
        // w_chet: 'Dung tích chết',
        // w_huuich: 'Dung tích hữu ích',
        // w_mndbt: 'Dung tích mực nước dâng bình thường',
        // w_tong: 'Dung tích tổng cộng',
        // mnc: 'Mực nước chết',
        // mndbt: 'Mực nước dâng bình thường',
        // mndgc: 'Mực nước dâng gia cường',
        // nxd: 'Năm xây dựng',
        // nht: 'Năm hoàn thành',
        // dvql: 'Đơn vị quản lý',
    },
    TuyenChuyenNuoc: {
        // FID: 'STT',
        // Ten_Tuyen: 'Tên tuyến chuyển nước',
        // Muctieu: 'Mục tiêu',
        // Tinh: 'Tỉnh',
        // Vung: 'Vùng',
        // Loai_CT: 'Loại công trình',
        // Loaihinh_D: 'Loại hình đầu tư',
        chieudai_k: 'Km',
        qchuyen_m3: 'm3/s',
        ft_ha: 'ha',
        // GD_2030: 'GĐĐT 2030',
        // GD_sau2030: 'GĐĐT sau 2030',
        // Ghichu: 'Ghichu',
    },
    congtrinh_xaymoi: {
        // FID: 'FID',
        // id: 'STT',
        // tenct: 'Tên công trình',
        // x: 'Toạ độ X',
        // y: 'Toạ độ Y',
        // tinh: 'Tỉnh',
        // vung: 'Vùng',
        // loai_ct: 'Loại công trình',
        // loaidautu: 'Loại đầu tư',
        wh_trieum3: 'Triệu m3',
        ftuoi_ha: 'ha',
        // chonglu: 'Chống lũ',
        // gd_2030: 'GĐĐT 2030',
        // gd_sau2030: 'GĐĐT sau 2030',
        // ghichu: 'Ghi chú',
        // phanloai1: 'phanloai1',
    },
    CongTrinh_nangcap: {
        // FID: 'FID',
        // id: 'STT',
        // tenct: 'Tên công trình',
        // x: 'Toạ độ X',
        // y: 'Toạ độ Y',
        // tinh: 'Tỉnh',
        // vung: 'Vùng',
        // loai_ct: 'Loại công trình',
        // loaidautu: 'Loại đầu tư',
        wh_trieum3: 'triệu m3',
        ftuoi_ha: 'ha',
        // chonglu: 'Chống lũ',
        // gd_2030: 'GĐĐT 2030',
        // gd_sau2030: 'GĐĐT sau 2030',
        // ghichu: 'ghichu',
        // phanloai: 'phanloai',
    },
    NangCap_HTTL: {
        // id: 'id',
        // tt: 'STT',
        // hethong: 'Hệ thống',
        // tenct: 'Tên hệ thống',
        // muctieu: 'Mục tiêu',
        // tinh: 'Tỉnh',
        // vung: 'Vùng',
        // loai_ct: 'Loại công trình',
        // loaihinh_d: 'Loại hình đầu tư',
        ftuoi_ha: 'ha',
        ftieu_ha: 'ha',
        // gd_2030: 'GĐĐT 2030',
        // gd_sau2030: 'GĐĐT sau 2030',
        // shape_leng: 'shape_leng',
        // shape_area: 'shape_area',
    },
    DanhMucQuyHoach: {
        ftuoi_tl: '%'
    },
    HeSoTuoiTieu: {
        // objectid: 'STT',
        // diadanh: 'Vùng:',
        ptuoilua20: '%',
        ptuoilua30: '%',
        ptuoilua50: '%',
        htuoilua20: 'l/s.ha',
        htuoilua30: 'l/s.ha',
        htuoilua50: 'l/s.ha',
        ptieulua20: '%',
        ptieulua30: '%',
        ptieulua50: '%',
        htieulua20: 'l/s.ha',
        htieulua30: 'l/s.ha',
        htieulua50: 'l/s.ha',
    }
}
